import { Component, OnInit, Output, EventEmitter, AfterContentInit, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { ActionsEventsService } from 'src/app/services/action.service';

@Component({
  selector: 'app-chn',
  templateUrl: './chn.component.html',
  styleUrls: ['./chn.component.scss']
})
export class ChnComponent implements OnInit {

  title = 'proyecto';
  public tabs_state;
  public param: any;
  isEN: boolean;

  languaje: string;

  constructor(private route: ActivatedRoute,
    private render: Renderer2,
    private titleService: Title,
    private actions: ActionsEventsService) {
    this.tabs_state = {
      rewards: true,
      rewards_app: false,
      privacy_notice_mr: false,
      voyage: false,
      use: false,
      cyber: false
    }
  }

  ngAfterContentInit() {
    this.render.addClass(document.getElementById('root'), 'chn');
  }

  ngOnInit() {
    this.route.queryParams.subscribe(params => {
      this.param = params['header'];
      let lang: string = params['lang'];
      if (lang) {
        if (lang.toLowerCase() === 'en') {
          this.languaje = 'en';
          sessionStorage.setItem('lang', lang);
          this.titleService.setTitle('Terms and Conditions');
        } else {
          this.languaje = lang;
          sessionStorage.setItem('lang', lang);
          this.titleService.setTitle('Términos y Condiciones');
        }
      }

      let isDeleteAccount = params['isDeleteAccount'] || 'false';

      if (JSON.parse(isDeleteAccount)) {

        this.tabs_state = {
          rewards: false,
          rewards_app: true,
          privacy_notice_mr: false,
          voyage: false,
          use: false,
          cyber: false
        }

        setTimeout(() => {

          let divDeleteAccount = document.getElementById('scroll-delete-account')
          console.log(divDeleteAccount);
          if (divDeleteAccount) {
            divDeleteAccount.scrollIntoView({ block: 'start', behavior: 'smooth' })
          }

          this.actions.goToDeleteAccountScroll();
        }, 1000);


      }
    });

    let lang = sessionStorage.getItem('lang');
    this.languaje = lang.toLowerCase();
  }

  resetFlags() {
    this.tabs_state = {
      rewards: false,
      rewards_app: false,
      privacy_notice_mr: false,
      voyage: false,
      use: false,
      cyber: false
    }
  }

}
